// note do not check this file in to source control
// as anyone who looks at our public repo would be able to copy the key

const API_KEY = "at_nwvlYhYKNuZ10ltmgl29dJTZ5ZUWq";

export default API_KEY;
